import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '@pieskowo/shared';

export abstract class BaseScene extends Phaser.Scene {
  protected get gameW(): number {
    return GAME_WIDTH;
  }
  protected get gameH(): number {
    return GAME_HEIGHT;
  }

  /**
   * WP13 — kolejkuje realne tło Toca-Boca do loadera sceny.
   * Wywołuj w preload(); klucz = id (np. 'bg_park'), plik /assets/real/<id>.png.
   */
  protected preloadRealBg(id: string): void {
    if (!this.textures.exists(id)) {
      this.load.image(id, `/assets/real/${id}.png`);
    }
  }

  /**
   * WP13 — wstawia realne tło na cały ekran, wyśrodkowane, bardzo nisko (pod treść).
   * Zwraca obraz (albo null, gdy tekstura nie została załadowana — bezpieczny fallback).
   */
  protected addRealBg(
    id: string,
    depth = -1000,
  ): Phaser.GameObjects.Image | null {
    if (!this.textures.exists(id)) return null;
    return this.add
      .image(this.gameW / 2, this.gameH / 2, id)
      .setDisplaySize(this.gameW, this.gameH)
      .setDepth(depth);
  }

  /** Kolorowe tło stubów + opcjonalny tytuł PL. */
  protected paintStub(bg: number, titlePl: string, subtitlePl?: string): void {
    this.cameras.main.setBackgroundColor(bg);
    const cx = this.gameW / 2;
    const cy = this.gameH / 2;
    this.add
      .text(cx, cy - 40, titlePl, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '42px',
        color: '#4a3f55',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    if (subtitlePl) {
      this.add
        .text(cx, cy + 20, subtitlePl, {
          fontFamily: 'system-ui, sans-serif',
          fontSize: '22px',
          color: '#6b5f7a',
        })
        .setOrigin(0.5);
    }
  }
}
